import { LoadingPage } from '@/features/city-clerk/ai-processing-progress'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/ai-processing-progress/',
)({
  beforeLoad: ({ context }) => {
    if (context.auth.loading) return
    if (!context.auth.userInfo?.uiCapabilities?.firstSubmittalView) {
      throw redirect({ to: '/access-denied' })
    }
  },
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      permitSubmitalId: (search.permitSubmitalId as string) || undefined,
    }
  },
})

function RouteComponent() {
  return <LoadingPage />
}
